import { deleteRequest, getWithParamsRequest, postRequest, putRequest } from '@rideiq/api/utils/provider';
import { ApiResponse } from '@rideiq/api/utils/responseTransform';
import { InvoiceGroup } from '@rideiq/organizers/features/InvoiceGroups/types';
import { QueryParamsForAssignRiders } from '@rideiq/organizers/types';

interface PaginationMeta {
  totalCount: number;
  perPage: number;
  page: number;
}

export async function getInvoiceGroups(
  queryParams: QueryParams,
  signal?: AbortSignal
): Promise<ApiResponse<{ invoiceGroups: InvoiceGroup[]; meta: PaginationMeta }>> {
  return getWithParamsRequest('invoice_groups', queryParams, signal);
}

export async function createInvoiceGroup(data: {
  name: string;
  poNumber?: string;
}): Promise<ApiResponse<{ invoiceGroup: InvoiceGroup }>> {
  return postRequest('invoice_groups', data);
}

export async function updateInvoiceGroup(
  id: number,
  data: { name: string; poNumber?: string }
): Promise<ApiResponse<{ invoiceGroup: InvoiceGroup }>> {
  return putRequest(`invoice_groups/${id}`, data);
}

export async function deleteInvoiceGroup(id: number): Promise<ApiResponse<null>> {
  return deleteRequest(`invoice_groups/${id}`);
}

export async function bulkAssignRidersToInvoiceGroup(
  invoiceGroupId: number,
  passengerIds: number[] | 'all',
  queryParams: QueryParamsForAssignRiders
): Promise<ApiResponse<{ message: string }>> {
  return postRequest(`invoice_groups/${invoiceGroupId}/assign_passengers`, { passengerIds, ...queryParams });
}
